import { connect } from "react-redux";
import { LoginPage } from "../pages/LoginPage";
import {
  signInWithGoogle,
  signUpWithEmailPassword,
  loginWithEmailPassword,
} from "../app/slices/authSlice";

export const Login = connect(
  function mapStateToProps(state) {
    return {
      loading: state.auth.status === "loading",
      error: state.auth.error,
    };
  },
  function mapDispatchToProps(dispatch) {
    return {
      onLoginWithGoogle: async (navigate) => {
        try {
          await dispatch(signInWithGoogle()).unwrap();
          navigate("/world");
        } catch (error) {
          console.error("Error during Google login:", error);
        }
      },
      onLogin: async (email, password, navigate) => {
        try {
          await dispatch(loginWithEmailPassword({ email, password })).unwrap();
          navigate("/world");
        } catch (error) {
          console.error("Error during login:", error);
        }
      },
      onSignup: async (email, password, navigate, name) => {
        try {
          await dispatch(
            signUpWithEmailPassword({ email, password, name }),
          ).unwrap();
          navigate("/world");
        } catch (error) {
          console.error("Error during signup:", error);
        }
      },
    };
  },
)(LoginPage);
